import React from "react";
import AnimatedSection from "components/animatedSection/AnimatedSection";
import Hero from "components/hero/Hero";
import Navbar from "components/navbar/Navbar";
import MCommerceSection from "components/animatedSection/MCommerceSection";
import "../../styles/landingPage.css"
const LandingPage = () => {
  return (
    <>
      <Navbar />
      <section className="landingPage section" id="landingPage">
        <Hero />
        <div className="animated__div grid">
          <AnimatedSection />
          <MCommerceSection />
        </div>
      </section>
    </>
  );
};

export default LandingPage;
